/**
 * Auth Redirection Utilities
 * Détermine la route par défaut selon le rôle utilisateur
 */

export const getDefaultRouteByRole = (role) => {
  switch (role) {
    case "super_admin":
    case "admin":
    case "manager":
      return "/admin/erp";
    case "employee":
      return "/employee/dashboard";
    case "client":
      return "/client/dashboard";
    default:
      console.warn(`Unknown role: ${role}. Redirecting to login.`);
      return "/auth/login";
  }
};

export const getUserStatusMeta = (status) => {
  switch (status) {
    case "active":
      return { label: "Actif", className: "status-badge status-active" };
    case "invited":
      return { label: "Invitation en attente", className: "status-badge status-invited" };
    case "disabled":
      return { label: "Désactivé", className: "status-badge status-disabled" };
    default:
      return { label: "Inconnu", className: "status-badge status-unknown" };
  }
};
